import { FeiertagEntry } from '@/domain/termine/features/Calendar/List/Feiertag/FeiertagEntry';
import { ListDayCell } from '@/domain/termine/features/Calendar/List/ListDayCell';
import { renderDayHeader } from '@/domain/termine/features/Calendar/List/ListDayHeader';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { Day } from '@/domain/termine/type';
import dayjs from 'dayjs';

interface ListDayProps {
  day: Day;
  week: Day[];
  currentMonth: number;
  currentYear: number;
}

export function ListDay({ day, week }: ListDayProps) {
  const { feiertage, termineByDay } = useCalendarContext();
  const today = dayjs().startOf('day').locale('de');

  const isToday = day.isSame(today, 'day');
  const hasFeiertag = feiertage.some((f) => dayjs(f.datum).isSame(day, 'day'));

  const isTodayInWeek = week.some((d) => d.isSame(today, 'day'));

  const termineForDay = termineByDay.get(day.format('YYYY-MM-DD')) ?? [];

  const isTodayTermin = termineForDay.length > 0;
  const showHeader =
    hasFeiertag ||
    termineForDay.length > 0 ||
    (isToday && isTodayInWeek && !isTodayTermin);

  return (
    <div key={day.format('DD-MM-YYYY')}>
      {renderDayHeader(day, isToday, showHeader)}
      <FeiertagEntry day={day} />
      <ListDayCell
        day={day}
        termineForDay={termineForDay}
        isToday={isToday}
        hasFeiertag={hasFeiertag}
        isTodayInWeek={isTodayInWeek}
        isTodayTermin={isTodayTermin}
      />
    </div>
  );
}
